<div class="modal" [ngClass]="{'show' :config?.showTAndC}">
  <div class="modal-content">
    <div class="modal-content__body-container conditions" #termsandconditions tabindex="-1">
      <h3 [translate]="titleKey"></h3>
      <div [innerHTML]="descriptionKey | translate"></div>
    </div>
    <app-navigable-button [x]="0" [y]="0"
                          [ownerComponent]="componentName"
                          (emitOnEnterPressed)="onEmitClose()"
                          (emitOnBack)="onBack()"
                          [shadow]="false"
                          class="btn-grey">
      <span class="button-text" [translate]="closeButtonTextKey"></span>
    </app-navigable-button>
  </div>
</div>
